<template>
    <div class="basic">
        <div class="basic-header">
            <p>企业基本信息</p>
        </div>
        <!-- <van-form label-width="7em" @submit="handleSubmit" ref="basicForm" validate-first @failed="onFailed"> -->
        <van-form label-width="7em" @submit="handleSubmit" ref="basicForm" validate-first>
            <!-- 企业基本信息   -->
            <van-field required v-model="formInline.companyName" name="companyName" label="企业名称" placeholder="企业名称全称"
                :rules="ruleInline.companyName" />
            <van-field required v-model="formInline.companyNameShort" name="companyNameShort" label="简称"
                placeholder="简称（2~4个字）" :rules="ruleInline.companyNameShort" />
            <van-field v-model="formInline.companyNameEn" name="companyNameEn" label="英文名称" placeholder="企业英文名称"
                :rules="ruleInline.companyNameEn" />
            <div>
                <!-- <van-field required readonly clickable name="addresss" :value="selectAddresTxt" right-icon="arrow" -->
                <van-field readonly clickable name="addresss" :value="selectAddresTxt" right-icon="arrow" label="企业地址"
                    placeholder="请选择企业地址" @click="showPicker = true" />
                <!-- label="企业地址" placeholder="请选择企业地址" :rules="ruleInline.addresss" @click="showPicker = true" /> -->
                <van-popup v-model="showPicker" round position="bottom">
                    <van-picker show-toolbar :columns="areaList" @confirm="onConfirm" @cancel="showPicker = false" />
                </van-popup>
            </div>
            <van-field v-model="formInline.address" name="address" label="详细地址" placeholder="请输入详细地址" />
            <!-- :rules="ruleInline.address"  /> -->
            <!-- 企业基本信息 end  -->

            <div class="gap"></div>

            <!-- 展会联系人信息   -->
            <div class="top-title">
                <div class="line"></div>
                展会联系人<span>*</span>
            </div>

            <van-field required v-model="formInline.linkMan" name="linkMan" label="姓名" placeholder="展会联系人姓名"
                :rules="ruleInline.linkMan" />
            <van-field required v-model="formInline.linkTitle" name="linkTitle" label="职务" placeholder="展会联系人职务"
                :rules="ruleInline.linkTitle" />
            <van-field type="number" required v-model="formInline.linkMob" name="linkMob" label="手机"
                placeholder="展会联系人手机 " :rules="ruleInline.linkMob" />
            <!-- :rules="ruleInline.linkEmail" -->
            <van-field v-model="formInline.linkEmail" name="linkEmail" label="邮箱" placeholder="展会联系人邮箱" />

            <div class="gap"></div>

            <!-- 参展展品*   -->
            <div class="top-title">
                <div class="line"></div>
                参展展品<span>*</span>
            </div>
            <van-field readonly required clickable label="所属行业" :value="formInline.industry" name="industry"
                :rules="ruleInline.industry" placeholder="请选择行业" @click="showPickerAdd = true" />
            <van-popup v-model="showPickerAdd" round position="bottom">
                <van-picker show-toolbar :columns="cityListInit" @cancel="showPickerAdd = false"
                    @confirm="onConfirmIndustry" />
            </van-popup>

            <van-field type="text" required v-model="formInline.highlightProducts" name="highlightProducts"
                label="重点展示产品" placeholder="产品名称 " :rules="ruleInline.highlightProducts" />

            <div class="gap"></div>

            <van-radio-group v-model="single">
                <div class="basic-header">
                    <p><span style="color: red;background-color: #1e88e5;    margin: 0 0px;">*</span>展位预定信息<span
                            style="color: red;" class="bgNone">（合作类型和展区任选其一即可）</span></p>
                </div>
                <div class="top-title disFlex">
                    <div class="disFlex">
                        <div class="line"></div>
                        <div>选择合作类型</div>
                    </div>
                    <div>
                        <van-radio name="已选择1" @click="radioClick1">选择</van-radio>
                    </div>
                </div>
                <!-- <div style="color: #666666;font-size: 10px;padding:10px 0">（置灰选项为售罄，不可选择） </div> -->
                <div style="padding: 10px 20px;">
                    <div :gutter="24" style=" display: flex;flex-wrap: wrap;">
                        <div v-for="(item, index) in listPavilion" :key="index" style="padding: 10px; ">
                            <!-- <van-button type="default" size="small"  @click="butChange(item,index)" :class="activeBut === index?'buttonCss':''" :disabled="item.tname=='首席'" >{{item.tname}}</van-button> -->
                            <div class="butButCss" style="background-color: #e6e6e6;color: #999999; width:120px"
                                v-if="item.tname == '首席'">首席</div>
                            <div class="butButCss" @click="butChange(item, index)" style="width:120px"
                                :class="activeBut === index ? 'buttonCss' : ''" v-if="item.tname != '首席'">{{
                                    item.tname
                                }}</div>
                        </div>
                    </div>

                    <div class="listPavilionDiv" v-for="(item, index) in showListDiv" :key="index">
                        <p v-if="item.text0">{{ item.text0 }}</p>
                        <p v-if="item.text1">{{ item.text1 }}</p>
                        <p v-if="item.text2">{{ item.text2 }}</p>
                        <p v-if="item.text3">{{ item.text3 }}</p>
                        <span v-if="item.text6">{{ item.text6 }}</span>
                        <span v-if="item.text4" style="color: #337FE5;">{{ item.text4 }}</span>
                        <span v-if="item.text5">{{ item.text5 }}</span>
                    </div>
                </div>

                <div class="gap"></div>

                <div class="top-title disFlex">
                    <div class="disFlex">
                        <div class="line"></div>
                        <div>选择展区</div>
                    </div>
                    <div>
                        <van-radio name="已选择2" @click="radioClick2">选择</van-radio>
                    </div>
                </div>
                <!-- <van-field v-model="formInline.linkMan" name="linkMan" label="选择展区" placeholder="选择展区" /> -->

                <van-field readonly clickable label="选择展区" label-width="60px" :value="exVal"
                    placeholder="请根据您所填公司所属行业选择对应展区" @click="showPickerEx = true" />
                <van-popup v-model="showPickerEx" round position="bottom">
                    <van-picker show-toolbar :columns="exAreaListInit" @cancel="showPickerEx = false"
                        @confirm="onConfirmSelectEx" />
                </van-popup>



                <div style="padding: 10px;">
                    <van-radio-group v-model="animal">
                        <van-radio name="光地" @click="onConfirmSelectEx(exVal)"
                            :disabled="sponsorDis">光地：2200/㎡（18㎡起）</van-radio>
                        <van-radio name="标展" @click="onConfirmSelectEx(exVal)" style="margin-top: 15px;"
                            :disabled="sponsorDis">标展：2400/㎡
                            （12㎡起）</van-radio>
                    </van-radio-group>

                    <p style="margin-top: 15px;"> 预定面积<InputNumber :max="99999999999" :min="1" v-model="value1"
                            @on-change="areaInputChange" :disabled="sponsorDis" style="margin-left: 10px;"
                            placeholder="请输入"></InputNumber> ㎡ </p>
                </div>
            </van-radio-group>
            <!-- <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div> -->
        </van-form>
        <div class="gap1"></div>
        <!-- <div class="basic-link" style="padding: 15px 10px  15px 10px;" >
                    <div style="">
                        <p style="font-size: 18px;font-weight: 700;">中国新建医院科技创新大会暨国际新建医院高科技创新解决方案博览会</p>
                        <p style="font-size: 14px;line-height: 25px;">&ensp;&ensp;
                            由筑医台、国药励展、筑而端联合多家权构共同举办的“中国新建医院科技创新大会暨国际新建医院高科技创新解决方案博览会”与CMEF第88届中国国际医疗器械（秋季)博览会将于2023年10月28-30日在深圳国际会展中心(宝安区) 同期举办，本届大会汇聚国内外医院建设领域顶级解决方案，引领医院建设科技创新最高水平，为产学研用各方呈现一场科技新高度、新体验的视觉盛宴。
                        </p>
                    </div>
            </div>
            <div class="gap1"></div> -->
    </div>
</template>

<script>
import { Popover } from 'vant';
import { Toast } from 'vant';
import mFormAddress from "@components/m-form/m-form-address.vue";
import { mapGetters, mapActions } from "vuex";
import country from "@assets/js/country2";
export default {
    name: "register-form", // 参展申请 - 基本信息
    components: {
        mFormAddress,
    },
    data() {
        const that = this;
        const zhValid = (value, callback) => {
            if (/^[\u4e00-\u9fa5]+$/.test(value)) {
                return true;
            } else {
                return false;
            }
        };
        // 判断英文
        const enValid = (value, callback) => {
            if (!value) {
                return true;
            } else {
                if (/^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(value)) {
                    return true;
                } else {
                    // callback(new Error('英文名称格式有误'));
                    return false;
                }
            }
        };

        const companyAddressValid = (value) => {
            if (that.formInline.addresss.country && that.formInline.addresss.country === '中国') { // 中国 判断省份和城市是否选择
                if (!that.formInline.addresss.province) {
                    return false;
                } else if (!that.formInline.addresss.city) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        };
        const validPhone = (value, callback) => {
            if (!value) {
                return false;
            } else if (/^[1][0-9]{10}$/.test(value)) {
                return true;
            } else {
                return false;
            }
        };
        const validEmail = (value, callback) => {
            if (!value) {
                return false;
            } else if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
                return true;
            } else {
                return false;
            }
        };
        const validCreditCode = (value, callback) => {
            if (!value) {
                return true;
            }
            var patrn = /^[0-9A-Z]+$/;
            //var patrn=/[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
            //18位校验及大写校验
            console.log(patrn.test(value), '正则的数据');
            if ((value.length != 18) || (patrn.test(value) == false)) {
                return false;
            }
            else {
                return true;
            }
        };
        return {
            areaList: [],
            showPicker: false,
            showPicker2: false,
            cityCode: '',  //省市区编号，默认
            loading: false,
            isInvoice: false,
            formInline: {
                // 企业基本信息
                companyName: "", // 公司名称
                companyNameShort: "", // 公司简称
                companyNameEn: "",// 公司英文名称
                creditCode: "", // 统一社会信用代码 
                address: "", // 详细地址
                addresss: {
                    country: "", // 国家
                    province: "", // 省份
                    city: "", // 城市
                    county: "", // 区县 
                },
                // 展会联系人
                linkMan: "",
                linkTitle: "",
                linkMob: "", // 电话号码
                linkEmail: "",

                // 所属行业
                industry: "",
                highlightProducts: "",
                // 选择展区
                selectEx: "",
            },
            formInline1: {
                // 企业基本信息
                companyName: "上海连战技术有限公司", // 公司名称
                companyNameShort: "连战", // 公司简称
                companyNameEn: "lianzhan",// 公司英文名称
                creditCode: "91310118MA1JM12CX7", // 统一社会信用代码 
                address: "金沙江西路1555路慧创国际16号2层", // 详细地址
                addresss: {
                    country: "中国", // 国家
                    province: "上海", // 省份
                    city: "嘉定", // 城市
                    county: "", // 区县 
                },
                postcode: "201803",
                productName: "技术服务",

                // 展会联系人
                linkMan: "李某",
                linkTitle: "技术",
                linkMob: "13122959676",
                linkEmail: "",
                linkCode: "021", // 区号
                linkTelephone: "05185055112", // 电话号码
                linkQQ: "2624006658",
                linkWeChat: "xiansheng",

                // 开票信息 
                invoiceTitle: "慕渊（上海）智能科技有限公司",
                invoiceCode: "91310118MA1JM12CX7",
                invoiceAddress: "上海上海市嘉定区江桥镇金沙江西路1555路慧创国际16号2层",
                invoiceTelephone: "13122959676",
                invoiceBank: "招商银行",
                invoiceBankAccount: "6214837922727635",
                invoiceType: "增值税专票",
                invoiceMalingAdresss: {
                    country: "中国", // 国家
                    province: "上海", // 省份
                    city: "嘉定", // 城市
                    county: "", // 区县 
                },
                invoiceMalingAdress: "江桥镇金沙江西路1555路慧创国际16号2层",
                invoiceMalingCode: "201803",
                invoiceRecivePerson: "王二",
                invoiceReciveTel: "13122959677",
                l: "",
                // 所属行业
                industry: "行业",
                highlightProducts: "产品",
                // 选择展区
                selectEx: "选择展区",
            },
            ruleInline: {
                // 企业基本信息
                companyName: [
                    { required: true, message: "请输入企业名称全称", trigger: "onBlur" },
                    // { validator: zhValid, message: "公司名称格式有误", trigger: "onBlur" },
                ],
                companyNameShort: [
                    { required: true, message: "请输入公司简称", trigger: "onBlur" },
                    // {
                    //   validator: (value) => {
                    //     return /^.{2,4}$/.test(value)
                    //   }, message: '公司简称长度在2到4个字符', trigger: 'onBlur'
                    // },
                ],
                companyNameEn: [
                    { message: "请输入公司英文名称", trigger: "onBlur" },
                    { validator: enValid, message: "英文名称格式有误", trigger: "onBlur" },
                ],
                creditCode: [
                    {
                        required: true,
                        message: "统一社会信用代码不能为空",
                        trigger: "onBlur",
                    },
                    {
                        message: "请输入正确的统一社会信用代码",
                        validator: validCreditCode,
                        trigger: "onBlur",
                    },
                ],
                addresss: [{
                    required: true,
                    validator: companyAddressValid, trigger: "onBlur",
                    message: '请完善地址'
                }],
                address: [
                    { required: true, message: "请输入详细地址", trigger: "onBlur" },
                ],

                // 展会联系人
                linkMan: [{ required: true, message: "请输入姓名", trigger: "onBlur" }],
                linkTitle: [{ required: true, message: "请输入职务", trigger: "onBlur" }],
                linkMob: [
                    { required: true, message: '请输入手机号码', trigger: "onBlur" },
                    { validator: validPhone, message: "手机号码有误", trigger: "onBlur" }
                ],
                // linkEmail: [{ validator: validEmail, message: '邮箱格式有误', trigger: 'onBlur' }],

                // 所属行业
                industry: [{ required: true, message: "请选择所属行业", trigger: "onBlur" }],
                highlightProducts: [{ required: true, message: "请填写产品名称", trigger: "onBlur" }],
                selectEx: [{ required: true, message: "请选择展区", trigger: "onBlur" }],
            },
            defaultList: [],
            uploadList: [],
            uploadName: "",

            isExport: true, // 是否是外销企业
            isListed: true, // 是否是上市公司
            isTop500: true, // 是否是世界五百强
            isMicroEnterprise: true, // 是否为小微企业
            isHighTech: true, // 是否为高新技术企业  

            basicInfo: null,
            validateList: [],
            ElepropName: "", //验证错误的prop名
            companyId: "", //公司ID
            isOption: true, //企业经营类型是否是选择框 

            countryList: [],
            provinceArr: [],
            citiesArr: [],


            selectAddresTxt: '',
            selectAddresTxt2: '',

            listPavilion: [
                { tname: "首席", list: [{ text0: '', text1: '合作价格：190万起', text2: '展位面积：180平米起', text3: '其他权益：广告、列名、媒体、演讲及其他独家服务（具体权益内容请拨打010-68629938咨询）' }] },
                { tname: "VVIP", list: [{ text0: '合作数量：限10家', text1: '合作价格：65万起', text2: '展位面积：252平米起', text3: '其他权益：VIP展位、广告、列名、媒体、演讲及其他服务等' }] },
                { tname: "战略合作", list: [{ text0: '合作数量：限3家', text1: '合作价格：150万起', text2: '展位面积：180平米起', text3: '其他权益：VIP展位、广告、列名、媒体、演讲及其他服务等' }] },
                { tname: "深度支持", list: [{ text0: '合作数量：限3家', text1: '合作价格：110万起', text2: '展位面积：150平米起', text3: '其他权益：VIP展位、广告、列名、媒体、演讲及其他独家服务' }] },
                { tname: "支持单位", list: [{ text0: '合作数量：限15家', text1: '合作价格：68万起', text2: '展位面积：150平米起', text3: '其他权益：VIP展位、广告、列名、媒体、演讲及其他独家服务' }] },

                { tname: "荣誉赞助A", list: [{ text0: '合作数量：限20家', text1: '合作价格：35万起', text2: '展位面积：120平米起', text6: '其他权益：VIP展位、广告、列名、媒体、', text4: '演讲', text5: '及其他服务等' }] },
                { tname: "荣誉赞助B", list: [{ text0: '合作数量：限20家', text1: '合作价格：35万起', text2: '展位面积：120平米起', text6: '其他权益：VIP展位、', text4: '精品广告', text5: '、列名、媒体及其他服务等' }] },
                { tname: "荣誉赞助C", list: [{ text0: '合作数量：限20家', text1: '合作价格：24万起', text2: '展位面积：60平米起', text3: '其他权益：其他权益：VIP展位、广告、列名、媒体、演讲及其他服务等' }] },
                { tname: "荣誉赞助D", list: [{ text0: '合作数量：限20家', text1: '合作价格：24万起', text2: '展位面积：60平米起', text3: '其他权益：VIP展位、精品广告、列名、媒体及其他服务等' }] },
                // { tname: "光地展位", list: [{  text0: '2100 元人民币 / ㎡ ，18 ㎡起售，仅为一块空地 '}] },
                // { tname: "标准展位", list: [{  text0: '2300 元人民币 / ㎡，12 ㎡起售，包含基本家具、地毯、照明、插座、楣板'}] },
                { tname: "CHCC医院建设奖", list: [{ text0: 'CHCC医院建设奖战略合作单位' }] },
                { tname: "专场论坛合作", list: [{ text0: '企业专场论坛（协办）/论坛支持单位' }] },

                { tname: "演讲", list: [] },
                { tname: "媒体合作", list: [] },
                { tname: "广告合作", list: [] },



            ],
            showListDiv: [],
            animal: '已选择1',
            single: '',
            value1: 1,
            value: 1,
            valueIndustry: '',
            activeBut: '',
            showPickerAdd: false,
            columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
            exVal: "",
            sponsorVal: "",
            showPickerEx: false,
            sponsorDis: true,
            exAreaList: [],
            cityList: [],
            exAreaListInit: [],
            cityListInit: [],
            transferList: [],

        };
    },
    computed: {
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            exhibitionId: "getExhibitionId",
            company: "getCompany",
        }),
    },
    created() {
        this.initExArea()
        this.initAllHy()

        this.areaList = country;
        console.log(this.areaList);
        if (this.formInline.addresss && this.formInline.addresss.province) {
            this.selectAddresTxt = `${this.formInline.addresss.country}/${this.formInline.addresss.province}/${this.formInline.addresss.city}/${this.formInline.addresss.county}`
        }
        if (this.formInline.invoiceMalingAdresss && this.formInline.invoiceMalingAdresss.province) {
            this.selectAddresTxt2 = `${this.formInline.invoiceMalingAdresss.country}/${this.formInline.invoiceMalingAdresss.province}/${this.formInline.invoiceMalingAdresss.city}`
        }
    },
    methods: {
        ...mapActions({
            getAllExArea: "releaseModule/getAllExArea", //获取展区和订单
            getAllHy: "releaseModule/getAllHy", //获取行业

            getCityByParentId: "exhibitionModule/getCityByParentId",
            addApplyCompany: "addApplyCompany",
            editApplyCompany: "editApplyCompany",
        }),

        async initExArea() {
            let opt = {
                clientId: "24",
                languageType: "中文"
            };


            // this.exAreaList = await this.getAllExArea(opt);
            let list = await this.getAllExArea(opt);
            this.exAreaList = list
            list.map(e => {
                this.exAreaListInit.push(e.name)
            })
            // this.exAreaListInit.map((item, index) => {
            //     if (item == "VIP展区") {
            //         this.exAreaListInit.splice(index, 1);
            //     }
            // })

        },
        // 行业
        async initAllHy() {
            let opt = {
                groupId: "11"
            };

            // this.cityList = await this.getAllHy(opt);
            let list = await this.getAllHy(opt);
            this.cityList = list
            list.map(e => {
                this.cityListInit.push(e.hyxz)
            })
        },

        onSelect(action) {
            Toast(action.text);
        },
        getvalidate(prop, status, error) {
            if (status == false) {
                let opt = {
                    prop: prop,
                    status: status,
                };
                this.validateList.push(opt);
            }
        },
        deteleObject(obj) {
            var uniques = [];
            var stringify = {};
            for (var i = 0; i < obj.length; i++) {
                var keys = Object.keys(obj[i]);
                keys.sort(function (a, b) {
                    return Number(a) - Number(b);
                });
                var str = "";
                for (var j = 0; j < keys.length; j++) {
                    str += JSON.stringify(keys[j]);
                    str += JSON.stringify(obj[i][keys[j]]);
                }
                if (!stringify.hasOwnProperty(str)) {
                    uniques.push(obj[i]);
                    stringify[str] = true;
                }
            }
            uniques = uniques;
            return uniques;
        },
        validForm(name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    console.log(valid, "valid");
                    resolve(valid);
                });
            });
        },
        handleSuccess(res, file) {
            if (res && res.list.length) {
                file.url = res.list[0];
                this.uploadList.push({
                    name: this.uploadName,
                    url: res.list[0],
                    status: "finished",
                });
            } else {
                this.uploadName = "";
            }
        },
        handleFormatError(file) {
            this.uploadName = "";
            this.$Notice.warning({
                title: "文件格式是不正确的",
                desc: "请上传jpg或者png格式的图片",
            });
        },
        handleMaxSize(file) {
            this.uploadName = "";
            this.$Notice.warning({
                title: "文件大小超过限制",
                desc: "请上传小于2M的图片",
            });
        },
        handleBeforeUpload(e) {
            this.uploadName = e.name;
            const limitNum = 1;
            const check = this.uploadList.length < limitNum;
            if (!check) {
                this.$Notice.warning({
                    title: `最多上传${limitNum}张图片`,
                });
            }
            return check;
        },
        handleRemoveByArr(file) {
            const fileList = this.uploadList;
            this.uploadList.splice(fileList.indexOf(file), 1);
        },
        addAreaArr() {
            if (this.formInline.exportSalesArea.length > 4) {
                Toast.warning("最多可选五个");
                return;
            }
            this.formInline.exportSalesArea.push([]);
        },
        delAreaArr(i) {
            this.formInline.exportSalesArea.splice(i, 1);
        },
        //资产类型选择框变更
        getselect(value) {
            console.log(value, '类型');
            if (value === "其他") {
                this.isOption = false;
            } else {
                this.isOption = true;
            }
        },
        async handleSubmit() {
            Toast.loading('loading...');
            setTimeout(() => {
                Toast.clear();
            }, 5000);
            let res = await this.validateHandle();
            console.log('res', res);
            return Promise.resolve(res)
        },

        //校验邮箱格式
        checkEmail(email) {
            return RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(email)
        },

        async validateHandle() {
            return new Promise((resolve, reject) => {
                this.$refs.basicForm.validate().then(() => {
                    // 营业执照
                    let valid = true;
                    // let imgBusinessLicense = "";
                    // if (this.uploadList && this.uploadList.length) {
                    //     imgBusinessLicense = this.uploadList[0];
                    // } else {
                    //     Toast.fail("请上传营业执照");
                    //     valid = false;
                    // }
                    //   展位预定信息
                    if (!this.single) {
                        this.$Notice.warning({ title: `请选择展位预定信息` });
                        return
                    } else {
                        if (this.single == '已选择1') {
                            if (!this.sponsorVal) {
                                this.$Notice.warning({ title: `请选择合作类型` });
                                return
                            }
                        }
                        if (this.single == '已选择2') {
                            if (!this.exVal) {
                                this.$Notice.warning({ title: `请选择展区` });
                                return
                            }
                            if (!this.exVal) {
                                this.$Notice.warning({ title: `请选择展区` });
                                return
                            }
                            if (!this.animal) {
                                this.$Notice.error('请选择光地/标展');
                                return
                            }
                        }
                    }

                    if (this.formInline.linkEmail) {
                        if (!this.checkEmail(this.formInline.linkEmail)) {
                            this.$Notice.error('请填写正确的邮箱');
                            return
                        }
                    }
                    let form = this.formInline;
                    console.log('form', this.formInline);

                    // debugger
                    let formValue = {
                        companyName: form.companyName, // 公司名称
                        companyNameShort: form.companyNameShort, // 公司简称
                        companyNameEn: form.companyNameEn,// 公司英文名称
                        address: form.address, // 详细地址 
                        country: form.addresss.country,
                        province: form.addresss.province,
                        city: form.addresss.city,
                        county: form.addresss.county,

                        // 展会联系人
                        linkMan: form.linkMan,
                        linkTitle: form.linkTitle,
                        linkTelephone: form.linkMob,
                        linkEmail: form.linkEmail,

                        typeBusiness: form.industry,
                        productName: form.highlightProducts,

                        supportType: this.single == '已选择1' ? this.sponsorVal : '',//赞助类型



                    }
                    if (valid) {
                        Toast.clear();
                    }
                    resolve({ valid: valid, form: formValue, lists: this.transferList, });
                }).catch((res) => {
                    //   Toast.fail("表单验证失败");
                    console.log(res)
                    //验证失败
                    this.$refs.basicForm.scrollToField(res[0].name, true)
                    Toast.fail(res[0].message);
                    resolve({ valid: false, form: null });
                })
            });
        },
        onConfirm(value) {
            this.formInline.addresss.country = value[0] || '';
            this.formInline.addresss.province = value[1] || '';
            this.formInline.addresss.city = value[2] || '';
            this.formInline.addresss.county = value[3] || '';
            // this.selectAddresTxt = `${this.formInline.addresss.country ? this.formInline.addresss.country : ''}${this.formInline.addresss.province ? '/' + this.formInline.addresss.province : ''}${this.formInline.addresss.city ? '/' + this.formInline.addresss.city : ''}`;
            this.selectAddresTxt = `${this.formInline.addresss.country ? this.formInline.addresss.country : ''}${this.formInline.addresss.province ? '/' + this.formInline.addresss.province : ''}${this.formInline.addresss.city ? '/' + this.formInline.addresss.city : ''}${this.formInline.addresss.county ? '/' + this.formInline.addresss.county : ''}`;

            this.showPicker = false;
        },
        onConfirm2(value) {
            this.formInline.invoiceMalingAdresss.country = value[0] || '';
            this.formInline.invoiceMalingAdresss.province = value[1] || '';
            this.formInline.invoiceMalingAdresss.city = value[2] || '';
            this.selectAddresTxt2 = `${this.formInline.invoiceMalingAdresss.country ? this.formInline.invoiceMalingAdresss.country : ''}${this.formInline.invoiceMalingAdresss.province ? '/' + this.formInline.invoiceMalingAdresss.province : ''}${this.formInline.invoiceMalingAdresss.city ? '/' + this.formInline.invoiceMalingAdresss.city : ''}`;
            this.showPicker2 = false;
        },
        // onFailed (failed) { 
        //   const errors = failed.errors;
        //   console.log(errors);
        //   this.$refs.form.scrollToField(errors[0].name, true)
        // },
        areaInputChange(e) {
            if (this.exVal) {
                this.transferList[0].showArea = e
                this.transferList[0].hallCount = e
                this.transferList[0].applyBoothOrder.area = e
            } else {
                this.value1 = e
            }

        },
        butChange(e, index) {
            this.sponsorVal = e.tname
            this.showListDiv = e.list
            this.activeBut = index
            this.single = '已选择1'
            this.sponsorDis = true
            this.value1 = 0
            this.animal = ''

            this.transferList = []
            let order = {}
            this.exAreaList.map(i => {
                if (i.name == 'VIP展位') {
                    // this.exVal = i.name
                    i.pjNames.map(j => {
                        if (j.pjName.indexOf(e.tname) != -1) {
                            // if (j.pjName == e.tname) {
                            order.hallCount = 1//展位数量
                            order.pType = j.pType //币种
                            order.showArea = j.standstall	//预定面积
                            order.allMoney = j.price	//总价
                            order.applyBoothOrder = {
                                boothType: j.boothType,
                                unit: j.cunit,
                                dePjNameGroupId: i.id,
                                gpName: j.gpName,
                                groupId: j.groupId,
                                dePjNameGroupName: i.name,
                                pjCode: j.pjCode,
                                pjFormat: j.pjFormat,
                                unitPrice: j.price,
                                monetaryUnit: j.pType,
                                name: j.pjName,
                                area: j.standstall,
                            }

                            // }
                        }
                    })
                }
            })
            this.transferList.push(order)


        },
        onConfirmIndustry(value) {
            this.formInline.industry = value;
            this.showPickerAdd = false;
        },

        radioClick1(e) {
            this.sponsorDis = true
            this.value1 = 0
            this.animal = ''
        },
        radioClick2(e) {
            this.sponsorDis = false

        },
        onConfirmSelectEx(value) {

            this.single = '已选择2'
            this.sponsorDis = false


            this.exVal = value;
            this.showPickerEx = false;
            this.transferList = []
            let order = {}



            this.exAreaList.map(i => {
                if (i.name == value) {
                    i.pjNames.map(j => {

                        if (j.boothType == this.animal) {

                            this.value1 = j.standstall
                            order.hallCount = 1 //展位数量
                            order.pType = j.pType //币种
                            order.showArea = this.value1	//预定面积
                            order.allMoney = j.price	//总价
                            order.applyBoothOrder = {
                                boothType: j.boothType,
                                unit: j.cunit,
                                dePjNameGroupId: i.id,
                                gpName: j.gpName,
                                groupId: j.groupId,
                                dePjNameGroupName: i.name,
                                pjCode: j.pjCode,
                                pjFormat: j.pjFormat,
                                unitPrice: j.price,
                                monetaryUnit: j.pType,
                                name: j.pjName,
                                area: this.value1
                            }

                        }
                    })
                }
            })
            this.transferList.push(order)

        },
    },
};
</script>

<style scoped lang='scss'>
.basic {
    background-color: #ffff;

    /deep/ {
        .ivu-radio-checked .ivu-radio-inner {
            border-color: #1e88e5 !important;
        }

        .van-switch--on,
        .ivu-radio-inner:after {
            background-color: #1e88e5;
        }

        .van-button--info,
        .van-radio__icon--checked .van-icon,
        .ivu-switch-checked {
            border-color: #1e88e5;
            background-color: #1e88e5;
        }
    }

    &-header {
        width: 100%;
        height: 48px;
        background-color: #1e88e5;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
            line-height: 48px;
            font-size: 15px;
        }

        span {
            width: 30px;
            height: 15px;
            background-color: #fff;
            margin: 0 15px;
        }

        .bgNone {
            background-color: transparent;
            margin: 0;
        }
    }

    &-name {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-address {
        padding: 30px 0 10px 30px;
        background-color: #ededed;
    }

    &-phone {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-license {
        padding: 30px 0 10px 30px;
        background-color: #ededed;
    }

    .upload-btn {
        width: 105px;
        height: 105px;
        border: dotted 1px #bfbfbf;
        text-align: center;
        margin: 10px 16px;
        border-radius: 4px;

        img {
            display: inline-block;
            width: 25px;
            height: 25px;
            margin-top: 33px;
            margin-bottom: 10px;
        }

        div {
            font-size: 13px;
            color: #999;
        }
    }

    .license-img {
        display: flex;
        flex-wrap: wrap;

        &-list {
            line-height: 32px;
            padding: 0 10px;
            background-color: #fff;
            display: flex;
            align-items: center;
            margin-right: 10px;
            margin-bottom: 10px;

            span {
                color: #1e88e5;
                cursor: pointer;
            }

            .line {
                width: 1px;
                height: 24px;
                background-color: #e6e6e6;
                margin: 0 6px;
            }
        }
    }

    &-export {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-scale {
        padding: 30px 0 10px 30px;
        background-color: #ededed;
    }

    &-tech {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-link {
        padding: 0 30px;
        background-color: #ededed;

        .ivu-form-item {
            margin-bottom: 0;
            line-height: 48px;

            /deep/ .ivu-form-item-label {
                font-size: 18px;
                padding: 0;
            }
        }
    }

    &-links {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-leader {
        padding: 0 30px;
        background-color: #ededed;
        position: relative;

        .ivu-form-item {
            margin-bottom: 0;
            line-height: 48px;

            /deep/ .ivu-form-item-label {
                font-size: 18px;
                padding: 0;
            }
        }

        .above {
            position: absolute;
            left: 240px;
            top: 10px;
        }
    }

    &-leaders {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-invoiceType {
        padding: 0 30px;
        background-color: #ededed;
        line-height: 48px;
        display: flex;
        justify-content: space-between;

        .ivu-checkbox-wrapper {
            margin: 0;
        }

        span {
            color: #ff0000;
            margin-left: 5px;
        }
    }

    &-invoices {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }
}

.tip {
    padding: 10px 16px 0;

    .red {
        font-size: 13px;
        color: #f00;
    }

    .txt1 {
        font-size: 13px;
        color: #000;
        font-weight: bold;
    }

    .txt2 {
        font-size: 13px;
        color: #999;
    }
}

.gap {
    height: 15px;
    background: #f7f7f7;
    width: 100%;
}

.gap1 {
    height: 15px;
    background: #fff;
    width: 100%;
}

.top-title {
    padding: 10px 10px;
    align-items: center;
    padding-left: 15px;
    font-size: 15px;
    color: #333;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;

    .line {
        content: "";
        width: 3px;
        height: 15px;
        background-color: #1e88e5;
        margin-right: 7px;
    }

    span {
        font-size: 15px;
        color: #f00;
    }

    &-left {
        flex: 1;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        padding-right: 15px;
    }
}

.upload-btn2 {
    width: 105px;
    height: 105px;
    border: dotted 1px #bfbfbf;
    text-align: center;
    margin: 10px 16px;
    border-radius: 4px;
    position: relative;
    margin-left: 10px;

    img {
        position: absolute;
        width: 100%;
        height: 100%;
        margin: 0;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .cover {
        position: absolute;
        background: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        z-index: 3;

        .icon {}
    }
}

.listPavilionDiv {
    background-color: #ffffff;
    width: 100%;
    color: #333333;
    font-size: 13px;
    padding: 10px;
    margin: 10px 0 0 0;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.15);

}

.buttonCss {
    background-color: rgb(232, 243, 252);
    border-radius: 3px;
    border: solid 1px #1e88e5;
    color: #1e88e5;
}

.disFlex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.changeCss {
    border-radius: 32px;
    border-radius: 32px;
    width: 70px;
    height: 27px;
    font-size: 15px;
    text-align: center;
    line-height: 27px;
}

.butButCss {
    background-color: #f7f7f7;
    line-height: 32px;
    font-size: 13px;
    text-align: center;
    width: 80px;
    letter-spacing: 0px;
    border-radius: 3px
}
</style>
